import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from '../service/api-request.service'

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footer: any = [];
  merchant: any;
  // Is Prodh
  englishProdh: boolean = false;
  spanishProdh: boolean = false;
  isProdh: boolean = false;
  isIframeActive: boolean = false;
  showTermsNConditions: boolean;
  termsFooter: string = 'https://alwayson.recaudia.com/'
  privacyFooter: string = 'https://alwayson.recaudia.com/'


  constructor(
    private apiRequestsService: ApiRequestService,
  ) { }

  async ngOnInit() {
    let _ = this;
    let urlParse = location.href.split('/');
    let getWord = urlParse[3];
    getWord = getWord.includes('?') ? getWord.split('?')[0] : getWord;
    _.merchant = getWord;
    if(getWord != ''){
      await _.apiRequestsService.getDesign(_.merchant).subscribe(data => {
        _.footer = data['results'][0]['_configuration']['footer'];
        console.log('this is the footer', _.footer)
        if(_.footer.links && _.footer.links.length > 0 ){
          _.privacyFooter = _.footer.links[0].url
          _.termsFooter = _.footer.links[1].url
          console.log('Si hay links')
        }
      });
    }
    _.isCentroProdh();
    _.isIframeSubDomain();
  }

  isIframeSubDomain(){
    const _ = this;
    let subdomain: any = location.href;
    if(subdomain.includes('mini-alwaysondev')){
      _.showTermsNConditions = true;
    }
    if(subdomain.includes('mini-alwayson')){
      _.showTermsNConditions = true;
    }
  }

  isCentroProdh(){
    let _ = this;
    let parseUrl: any = location.href.split('/');
    if(parseUrl[3] == 'centroprodh'){
      _.englishProdh = false;
      _.spanishProdh = true;
      _.isProdh = true;
      return;
    }
    if(parseUrl[3] == 'centroprodhusd'){
      _.englishProdh = true;
      _.spanishProdh = false;
      _.isProdh = true;
      return;
    }
    _.englishProdh = false;
    _.spanishProdh = false;
    _.isProdh = false;
  }
}
